import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SearchResults } from 'hooks/search/types';

export type SearchState = {
  searchTerm: string;
  searchResults: SearchResults | undefined;
};

type SelectorState = { search: SearchState };

export const initialSearchState: SearchState = {
  searchTerm: '',
  searchResults: undefined,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState: initialSearchState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setSearchResults: (state, action: PayloadAction<SearchResults>) => {
      state.searchResults = action.payload;
    },
    clearSearchTerm: (state) => {
      state.searchTerm = initialSearchState.searchTerm;
      state.searchResults = initialSearchState.searchResults;
    },
  },
});

export const {
  setSearchTerm,
  setSearchResults,
  clearSearchTerm,
} = searchSlice.actions;

export const getSearchTerm = (state: SelectorState) => state.search.searchTerm;

export const getSearchResults = (state: SelectorState) =>
  state.search.searchResults;

export default searchSlice.reducer;
